import { CommonModule } from '@angular/common';
import { AuditDirectoryCellComponent } from '../../shared/audit/audit-directory-cell.component';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { forkJoin } from 'rxjs';
import { app_permissions } from '../../security/app-permissions';
import { PermissionService } from '../../security/permission.service';
import { REFURBISHMENT_SOURCES, statusSeverity, warehousingBreadcrumb, warehousingHomeBreadcrumb } from '../warehousing-common';
import { WarehousingDestruction, WarehousingItem, WarehousingSearchFilters } from '../warehousing.model';
import { WarehousingPageHeaderComponent } from '../warehousing-page-header.component';
import { WarehousingSearchPanelComponent } from '../warehousing-search-panel.component';
import { WarehousingService } from '../warehousing.service';
import { itemIdentityLabel } from '../warehousing-item-display';

@Component({
  selector: 'app-warehousing-destruction',
  standalone: true,
  imports: [AuditDirectoryCellComponent,
    CommonModule, ReactiveFormsModule, RouterModule, BreadcrumbModule, ButtonModule, IftaLabelModule,
    InputGroupModule, InputGroupAddonModule, InputTextModule, ProgressBarModule, SelectModule, TableModule,
    TagModule, WarehousingPageHeaderComponent, WarehousingSearchPanelComponent
  ],
  templateUrl: './warehousing-destruction.component.html'
})
export class WarehousingDestructionComponent implements OnInit {
  private fb = inject(FormBuilder);
  private warehousingService = inject(WarehousingService);
  private permissionService = inject(PermissionService);

  isLoading = false;
  breadcrumbItems: MenuItem[] = warehousingBreadcrumb('Destruction');
  homeBreadcrumb: MenuItem = warehousingHomeBreadcrumb();
  destructions: WarehousingDestruction[] = [];
  items: WarehousingItem[] = [];
  destructionSources = REFURBISHMENT_SOURCES;
  destructionStatusOptions = [
    { label: 'Draft', value: 'DRAFT' },
    { label: 'Confirmed', value: 'CONFIRMED' },
    { label: 'Cancelled', value: 'CANCELLED' }
  ];

  searchForm = this.fb.group({
    keyword: [''],
    sourceType: [null as string | null],
    status: [null as string | null]
  });

  ngOnInit(): void {
    this.loadDestructions();
  }

  loadDestructions(): void {
    this.isLoading = true;
    forkJoin({
      destructions: this.warehousingService.getDestructions(this.searchFilters()),
      items: this.warehousingService.getItems()
    }).subscribe({
      next: response => {
        this.destructions = response.destructions.data || [];
        this.items = response.items.data || [];
        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  applySearch(): void {
    this.loadDestructions();
  }

  clearSearch(): void {
    this.searchForm.reset({
      keyword: '',
      sourceType: null,
      status: null
    });
    this.loadDestructions();
  }

  canCreate(): boolean {
    return this.permissionService.hasPermission(app_permissions.warehousing.destruction.create);
  }

  itemName(id?: number): string {
    const item = this.items.find(row => row.id === id);
    return itemIdentityLabel(item);
  }

  supplierName(destruction: WarehousingDestruction): string {
    return destruction.supplierClientName || destruction.vendorName || 'Internal team';
  }

  statusSeverity = statusSeverity;

  private searchFilters(): WarehousingSearchFilters {
    return this.searchForm.getRawValue();
  }
}
